export const globalParams = {
  renderType: null,
  renderTypeSize: {},
  tagTypeColors: {},
  statusTypeColors: {},
  renderMobile: {}
};
